import { h } from 'vue'
import OrganismCardIntegration from '~/components/organisms/card-integration/card-integration.vue'
import OrganismHero from '~/components/organisms/hero/hero.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'

const Functional = (props) => {
  return h(UiComponentContainer, { class: 'full-integrations' }, () => [
    h(OrganismHero, {}, {
      heading: () => props.record.title,
      paragraph: () => props.record.text,
    }),
    h(
      UiComponentParagraph,
      { class: 'subtitle' },
      () => [props.record.subtitle],
    ),
    h(UiComponentContainer, {}, () => [
      props.record?.integrations.map((integration) => {
        return (
          integration.cardTitle
          && h(OrganismCardIntegration, {
            integration: {
              category: integration.cardLabel,
              description: integration.cardDescription,
              logo: integration.cardLogo,
              name: integration.cardTitle,
            },
          })
        )
      }),
    ]),
  ])
}

Functional.props = {
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
